const NoteEmpty = () => {
    return(
        <>
            <div className="flex justify-center">
                <p className="text-center text-md text-slate-500">No records ...</p>
            </div>
        </>
    );
}

export default NoteEmpty;